import React from "react";
import { PaintBrush } from "@phosphor-icons/react";
import { unitsAtPainter } from "@/lib/paintApi";

/**
 * Per-item badge rendered on OrderDetail line-item rows when the item has
 * units currently at the painter. Complements the mobile scanner's paint
 * status; on the web this is display-only.
 */
export default function PaintStatusPill({ item, className = "" }) {
  const atPainter = unitsAtPainter(item);
  if (atPainter <= 0) return null;
  return (
    <span
      className={`inline-flex items-center gap-1 text-[10px] uppercase tracking-[0.15em] font-black rounded-md px-2 py-1 border whitespace-nowrap bg-purple-100 text-purple-800 border-purple-300 dark:bg-purple-950/40 dark:text-purple-300 dark:border-purple-800 ${className}`}
      data-testid={`paint-pill-${item.id || item.sku}`}
      title={`${atPainter} of ${item.units_total || 0} unit(s) at painter${item.paint_vendor_notes ? ` · ${item.paint_vendor_notes}` : ""}`}
    >
      <PaintBrush size={11} weight="fill" />
      At painter · {atPainter}
    </span>
  );
}
